import { setProducts } from "../store/slices/product-slice";
import appConfig from "../data/config";

export const fetchProductsIfNeeded = () => async (dispatch, getState) => {
  const state = getState();
  const { products, lastFetch, lastFetchToken, lastFetchClientId } = state.product;
  const token = state.auth?.token ?? null;
  const selectedClient = state.viajante?.selectedClient ?? null;
  const isViajante = state.auth?.user?.role === 'viajante';
  const clientId = (isViajante && selectedClient) ? selectedClient.id : null;

  const cacheDuration = appConfig.productCacheMinutes * 60 * 1000;
  const tokenChanged = token !== lastFetchToken;
  const clientChanged = clientId !== lastFetchClientId;
  const cacheValid = products.length > 0 && lastFetch && (Date.now() - lastFetch <= cacheDuration);

  if (!tokenChanged && !clientChanged && cacheValid) return 'cached';

  try {
    const url = new URL(`${appConfig.apiUrl}/products`, window.location.href);
    if (clientId) url.searchParams.set('as_client_id', clientId);

    const headers = { Accept: 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(url.toString(), { headers });
    if (!response.ok) throw new Error('La respuesta de la red no fue correcta');

    const data = await response.json();
    const items = Array.isArray(data) ? data : (data.data ?? []);

    const formattedProducts = items.map(p => ({
      ...p,
      id: p.code,
      sku: p.code,
      price: parseFloat(p.user_price ?? p.price) || 0,
      precio_sugerido: parseFloat(p.precio_sugerido) || null,
      discount: p.discount && parseFloat(p.discount) > 0 ? parseFloat(p.discount) : null,
      fullDescription: p.fullDescription?.trim() || null,
      new: !!p.new,
      category: Array.isArray(p.category) ? p.category : JSON.parse(p.category || '[]'),
      quantityPerBox: p.quantityPerBox,
      tag: Array.isArray(p.tag) ? p.tag : JSON.parse(p.tag || '[]'),
      image: (Array.isArray(p.image) ? p.image : JSON.parse(p.image || '[]')).map(img =>
        img.startsWith('http') ? img : `${appConfig.imageBaseUrl}/${img}`
      ),
      familia: p.familia || null,
      subfamilia: p.subfamilia || null,
      categoria: p.categoria || null,
    }));

    dispatch(setProducts({ products: formattedProducts, token, clientId }));
    return 'loaded';
  } catch (error) {
    console.error("Fallo al obtener los productos:", error);
    // El resultado deja que la pantalla distinga "falló" de "el producto no existe".
    return 'error';
  }
};
